module.exports = __webpack_public_path__ + "img/Pattern-mob-Background.688f98a.jpg";